import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.search";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import MagneticToCursor from '../animations/MagneticToCursor';
import StandardSwipe from './StandardSwipe';
import initSliders from './initSliders';

var HistorySwipe = /*#__PURE__*/function () {
  function HistorySwipe(container) {
    _classCallCheck(this, HistorySwipe);

    this.container = container;
    this.config = {
      loop: true,
      speed: 600,
      spaceBetween: 20,
      centeredSlides: true,
      breakpoints: {
        1024: {
          slidesPerView: 3,
          centeredSlides: false,
          spaceBetween: 0,
          slideToClickedSlide: true
        }
      }
    };
    this.slider = null;
  }

  _createClass(HistorySwipe, [{
    key: "swiperEvents",
    value: function swiperEvents() {
      var _this = this;

      var sliderMagnets = [];
      this.slider.standardSwiper.on('init', function () {
        var cards = _this.container.querySelectorAll('.history-slider__inner');

        var startingBreakpoint = 1024;
        cards.forEach(function (card) {
          var newMagnet = new MagneticToCursor(card, startingBreakpoint);
          newMagnet.init();
          sliderMagnets.push(newMagnet);
        });
      });
      this.slider.standardSwiper.on('slideChangeTransitionEnd', function () {
        var activeSlug = _this.container.querySelector('.swiper-slide-active').dataset.slug;

        _this.updateUrl(activeSlug);

        _this.updateContent();

        sliderMagnets.forEach(function (magnet) {
          return magnet.init();
        });
      });
    }
  }, {
    key: "getURLParams",
    value: function getURLParams() {
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var param = urlParams.get('product');

      if (param) {
        return param;
      }

      return;
    }
  }, {
    key: "showSlider",
    value: function showSlider() {
      this.container.classList.add('loaded');
    }
  }, {
    key: "updateUrl",
    value: function updateUrl(slug) {
      var params = new URLSearchParams(window.location.search);
      params.set('product', slug);
      window.history.replaceState({}, '', decodeURIComponent("".concat(window.location.pathname, "?").concat(params)));
    }
  }, {
    key: "setActiveIndex",
    value: function setActiveIndex() {
      var _this2 = this;

      var slides = this.container.querySelectorAll('.swiper-slide');
      var activeIndex = 0;

      if (this.getURLParams()) {
        if (slides.length > 0) {
          slides.forEach(function (slide) {
            var slideSlug = slide.dataset.slug;

            if (_this2.getURLParams() === slideSlug) {
              activeIndex = _toConsumableArray(slides).indexOf(slide);
            }
          });
        }
      } else {
        this.updateUrl(slides[activeIndex].dataset.slug);
      }

      this.loadSlider(activeIndex);
      this.updateContent();
    }
  }, {
    key: "updateContent",
    value: function updateContent() {
      var activeSlug = this.container.querySelector('.swiper-slide-active').dataset.slug;
      var contentPanels = document.querySelectorAll('[data-history-content]');

      if (contentPanels.length > 0) {
        contentPanels.forEach(function (panel) {
          panel.dataset.historyContent === activeSlug ? panel.classList.add('show') : panel.classList.remove('show');
        });
      }
    }
  }, {
    key: "loadSlider",
    value: function loadSlider(index) {
      this.slider = new StandardSwipe(this.container, _objectSpread(_objectSpread({}, this.config), {}, {
        initialSlide: index
      }));
      initSliders([this.slider]);
      this.showSlider();
    }
  }, {
    key: "init",
    value: function init() {
      this.setActiveIndex();
      this.swiperEvents();
    }
  }]);

  return HistorySwipe;
}();

export default HistorySwipe;